import { DocumentNode, gql } from '@apollo/client';
import {
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuButtonProps,
  MenuList,
} from '@chakra-ui/react';
import * as React from 'react';

import { MoreHorizontalIcon } from '@/imports/ui/chakra/feather';

import { DropdownMenu_CommentFragment } from './graphql-types/DropdownMenu_CommentFragment';

import { DeleteCommentDropdownItem } from './components/DeleteCommentDropdownItem';
import { EditCommentDropdownItem } from './components/EditCommentDropdownItem/EditCommentDropdownItem';
import { ReportCommentDropdownItem } from './components/ReportCommentDropdownItem';

export const DropdownMenu: React.FC<
  {
    comment: DropdownMenu_CommentFragment;
    onClickEdit: () => void;
  } & MenuButtonProps
> & {
  commentFragment: DocumentNode;
} = ({ comment, onClickEdit, ...menuButtonProps }) => {
  return (
    <Menu>
      <MenuButton
        as={IconButton}
        variant="ghost"
        colorScheme="gray"
        isRound
        icon={<Icon as={MoreHorizontalIcon} />}
        size="sm"
        {...menuButtonProps}
      />
      <MenuList>
        <ReportCommentDropdownItem comment={comment} />
        {comment.currentUserCanUpdateComment && (
          <EditCommentDropdownItem
            comment={comment}
            onClickEdit={onClickEdit}
          />
        )}
        {comment.currentUserCanDeleteComment && (
          <DeleteCommentDropdownItem comment={comment} />
        )}
      </MenuList>
    </Menu>
  );
};

DropdownMenu.commentFragment = gql`
  fragment DropdownMenu_CommentFragment on Comment {
    _id
    currentUserCanUpdateComment
    currentUserCanDeleteComment
    ...DeleteCommentDropdownItem_CommentFragment
    ...ReportCommentDropdownItem_CommentFragment
  }
  ${DeleteCommentDropdownItem.commentFragment}
  ${ReportCommentDropdownItem.commentFragment}
`;
